import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

var _templateObject, _templateObject2, _templateObject3;

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import Link from 'next/link';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import { Dropdown } from '@yoweb/ui/components/Dropdown';
import { Grid } from '@yoweb/ui/components/Grid';
import { Spacer } from '@yoweb/ui/components/Spacer';
import { LogoAnchor } from '@yoweb/ui/components/LogoAnchor';
import { Header as BaseHeader } from '@yoweb/ui/components/Header';
import { Box } from '@yoweb/ui/components/Box';
import { Spinner } from '@yoweb/ui/components/Spinner';
import { Button, ButtonNav } from '@yoweb/ui/components/buttons';
import { breakpoints, media } from '@yoweb/ui/styles/utils';
import { getColor, getSpace } from '@yoweb/ui/styles/utils/theme';
import { CaretDownIcon } from '@yoweb/ui/components/Icon/CaretDownIcon';
import { Text, Title } from '@yoweb/ui/components/typography';
import { useTranslation } from '@yoweb/next-i18next';
import { useUser } from '@store/hooks/useUser';
import { API_LOGIN, API_LOGOUT, PAGE_INDEX, PAGE_ACCOUNT, PAGE_CHECKOUT_PLAN, PAGE_CHECKOUT_REDIRECT, PAGE_HOME, API_SIGNUP, PAGE_INTRODUCTION_PANASONIC_YOHANA } from '@store/constants/routes';
import MenuButton from '@store/components/Header/MenuButton';
import MobileNavContainer, { RenderState, ColorMode } from '@store/components/Mobile/NavContainer';
import UserMenuLinks from '@store/components/UserMenuLinks';
import userAvatarFallback from '@store/public/images/user-avatar-fallback.png';
import { GiftBanner } from '@store/components/Gift';
import { QUERY_PARAM_LOCALE, QUERY_PARAM_REDIRECT_TO } from '@yoweb/utils/constants/queryParams';
import { useExternalConfig } from '@store/contexts/ExternalConfig';
import { OpenNewWindowIcon } from '@yoweb/ui/components/Icon/OpenNewWindowIcon';
import { Avatar } from '@yoweb/ui/components/Avatar';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { logoutEvent } from '@yoweb/utils/analytics/mixpanel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AsyncDirectToPurchaseModal = dynamic(function () {
  return import('@store/components/PurchaseFlow/DirectToPurchaseModal');
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak('@store/components/PurchaseFlow/DirectToPurchaseModal')];
    }
  }
});
export var HEADER_ID = 'main-header';

var doDelay = function doDelay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

export var Header = function Header(_ref) {
  var _user$profile, _user$profile2, _user$profile2$name, _user$profile3, _user$profile4, _user$profile4$name;

  var navLinks = _ref.navLinks,
      _ref$hideLinksOnRoute = _ref.hideLinksOnRoutes,
      hideLinksOnRoutes = _ref$hideLinksOnRoute === void 0 ? [] : _ref$hideLinksOnRoute,
      _ref$showEmptySpace = _ref.showEmptySpace,
      showEmptySpace = _ref$showEmptySpace === void 0 ? true : _ref$showEmptySpace,
      _ref$hideJoinButton = _ref.hideJoinButton,
      hideJoinButton = _ref$hideJoinButton === void 0 ? true : _ref$hideJoinButton,
      _ref$showSignInOnBann = _ref.showSignInOnBanner,
      showSignInOnBanner = _ref$showSignInOnBann === void 0 ? false : _ref$showSignInOnBann,
      _ref$hideGiftBanner = _ref.hideGiftBanner,
      hideGiftBanner = _ref$hideGiftBanner === void 0 ? false : _ref$hideGiftBanner,
      _ref$animateIn = _ref.animateIn,
      animateIn = _ref$animateIn === void 0 ? true : _ref$animateIn;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var _useExternalConfig = useExternalConfig(),
      basePoplarURL = _useExternalConfig.basePoplarURL,
      _useExternalConfig$gl = _useExternalConfig.globalFeatures,
      enableWaitlist = _useExternalConfig$gl.enableWaitlist,
      enableOnboarding2_2 = _useExternalConfig$gl.enableOnboarding2_2,
      enableSkipPostalValidation = _useExternalConfig$gl.enableSkipPostalValidation,
      isPoplarPreviewEnabled = _useExternalConfig$gl.enablePoplarPreview,
      enableRemovalSignUpYohanaUs = _useExternalConfig$gl.enableRemovalSignUpYohanaUs,
      mixpanel = _useExternalConfig.mixpanel;

  var theme = useTheme();
  var user = useUser();

  var _useRouter = useRouter(),
      pathname = _useRouter.pathname,
      prefetch = _useRouter.prefetch,
      push = _useRouter.push,
      events = _useRouter.events;

  var _useState = useState(false),
      isNavigating = _useState[0],
      setNavigating = _useState[1];

  var _useState2 = useState(false),
      isBannerVisible = _useState2[0],
      setIsBannerVisible = _useState2[1];

  var _useState3 = useState(RenderState.CLOSED),
      mobileNavState = _useState3[0],
      setMobileNavState = _useState3[1];

  var _useState4 = useState(RenderState.CLOSED),
      mobileMenuState = _useState4[0],
      setMobileMenuState = _useState4[1];

  var _useState5 = useState(RenderState.CLOSED),
      desktopMenuState = _useState5[0],
      setDesktopMenuState = _useState5[1];

  var _useState6 = useState(false),
      isDirectPurchaseModalOpen = _useState6[0],
      setIsDirectPurchaseModalOpen = _useState6[1];

  var router = useRouter();

  var _useIntlMeta = useIntlMeta(),
      lcLocale = _useIntlMeta.lcLocale;

  var isJapanLocale = lcLocale === 'ja-jp';

  var closeAllMenus = function closeAllMenus() {
    setMobileNavState(RenderState.CLOSED);
    setMobileMenuState(RenderState.CLOSED);
    setDesktopMenuState(RenderState.CLOSED);
  };

  var toggleMobileNav = function toggleMobileNav() {
    if (isNavigating) {
      return;
    }

    setMobileNavState(mobileNavState === RenderState.OPEN ? RenderState.CLOSED : RenderState.OPEN);
  };

  useEffect(function () {
    closeAllMenus();
    window.addEventListener('resize', closeAllMenus);
    return function () {
      window.removeEventListener('resize', closeAllMenus);
    };
  }, []);
  var userMenuDropdown = 'user-menu-dropdown';

  var handleLinkClicked = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event, to) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              event.preventDefault();

              if (!(pathname === to)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              setNavigating(true);
              void prefetch(to);
              _context.next = 7;
              return doDelay(theme.transitionDuration.visual);

            case 7:
              window.scrollTo(0, 0);
              void push(to);

              if (to.split('#')[0] === pathname) {
                closeAllMenus();
                setNavigating(false);
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleLinkClicked(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(); // Close menus and white overlay when we are done navigating.


  useEffect(function () {
    var onRouteChangeComplete = function onRouteChangeComplete() {
      closeAllMenus();
      setNavigating(false);
    };

    events.on('routeChangeComplete', onRouteChangeComplete);
    return function () {
      events.off('routeChangeComplete', onRouteChangeComplete);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var showSpinner = false;
  var showDefaultButtons = true;
  var showAccountButtons = false; // Send the user to purchase flow login page. Upon login, it will redirect to the checkout plan, which
  // will direct user to the correct place:
  // If user is a... preview aka free or cancelled user -> next purchase flow step
  //             ... active or past due users -> poplar

  var loginUrl = "".concat(API_LOGIN, "?").concat(QUERY_PARAM_REDIRECT_TO, "=").concat(PAGE_CHECKOUT_PLAN, "&"); // If isJapanLocale and isAuthenticated redirect to poplar per GMR-434

  if (isJapanLocale && user.isAuthenticated) {
    loginUrl = "".concat(PAGE_HOME(basePoplarURL), "?");
  } else if (isJapanLocale && !user.isAuthenticated) {
    loginUrl = "".concat(API_SIGNUP, "?").concat(QUERY_PARAM_REDIRECT_TO, "=").concat(PAGE_CHECKOUT_PLAN, "&");
  } // For waitlist flow, continue to show the poplar and account buttons instead of the
  // 'get started' and 'sign in' buttons when the user is logged in.


  if (enableWaitlist) {
    // Send the user to the login page, returning to the current page in store after login,
    // not the checkout page.
    loginUrl = "".concat(API_LOGIN, "?"); // If user is loading, only show the spinner, no buttons

    if (user.isLoading) {
      showSpinner = true;
      showDefaultButtons = false;
    } else {
      showSpinner = false; // Show account buttons if user is unauthenticated

      showAccountButtons = user.isAuthenticated; // Only show one set of buttons at once

      showDefaultButtons = !showAccountButtons;
    }
  }

  if (enableOnboarding2_2 || isPoplarPreviewEnabled) {
    loginUrl = "".concat(API_LOGIN, "?").concat(QUERY_PARAM_REDIRECT_TO, "=").concat(PAGE_CHECKOUT_REDIRECT, "&");
  }

  loginUrl += "".concat(QUERY_PARAM_LOCALE, "=").concat(i18n.language); // If enableRemovalSignUpYohanaUs is true, we want to use the poplar auth0 template

  if (enableRemovalSignUpYohanaUs) {
    loginUrl = "".concat(PAGE_HOME(basePoplarURL));
  }

  var joinButtonOnClick = function joinButtonOnClick() {
    // If in Japan OR the waitlist is enabled in the US, send to the DirectToPurchaseModal
    // If enable_store_skip_japan_postal_validation is OFF or enable_waitlist flag is ON or we still want to go through the zip code validation
    // Else if in US and there's capacity (enable_waitlist flag is OFF), send to direct purchase flow,
    // Adding an extra check for Japan locale to redirect to the Introduction page
    if (isJapanLocale && !enableSkipPostalValidation || enableWaitlist) {
      setIsDirectPurchaseModalOpen(true);
    } else {
      void router.push(isJapanLocale ? PAGE_INTRODUCTION_PANASONIC_YOHANA : "".concat(API_SIGNUP, "?").concat(QUERY_PARAM_REDIRECT_TO, "=").concat(PAGE_CHECKOUT_REDIRECT, "&"));
    }
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!hideGiftBanner && /*#__PURE__*/_jsx(GiftBanner, {
      onClose: function onClose() {
        return setIsBannerVisible(false);
      },
      onCtaClick: joinButtonOnClick,
      onLoaded: function onLoaded(isVisible) {
        setIsBannerVisible(isVisible);
      }
    }), /*#__PURE__*/_jsx(AsyncDirectToPurchaseModal, {
      isOpen: isDirectPurchaseModalOpen,
      isWaitlistEnabled: enableWaitlist,
      onClose: function onClose() {
        return setIsDirectPurchaseModalOpen(false);
      }
    }), /*#__PURE__*/_jsx(Box, {
      position: "relative",
      children: /*#__PURE__*/_jsxs(BaseHeader, {
        id: HEADER_ID,
        showEmptySpace: showEmptySpace,
        animateIn: animateIn,
        "data-testid": "header-content-container",
        isBannerVisible: isBannerVisible,
        children: [/*#__PURE__*/_jsxs(Grid, {
          flow: "column",
          align: "center",
          justify: "space-between",
          "data-testid": "desktop-outer-nav-grid",
          children: [/*#__PURE__*/_jsx(LogoAnchor, {
            href: PAGE_INDEX,
            isOpen: mobileNavState === RenderState.OPEN
          }), !hideLinksOnRoutes.includes(pathname) && /*#__PURE__*/_jsxs(Grid, {
            flow: "column",
            align: "center",
            gap: "normal2",
            children: [/*#__PURE__*/_jsx(DesktopView, {
              children: /*#__PURE__*/_jsx(DesktopNavigation, {
                "data-testid": "page-nav-grid",
                children: navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (_ref3) {
                  var title = _ref3.title,
                      href = _ref3.href;
                  var isActive = pathname.includes(href);
                  return /*#__PURE__*/_jsx(Link, {
                    href: href,
                    passHref: true,
                    legacyBehavior: true,
                    children: /*#__PURE__*/_jsx(ButtonNav, {
                      isActive: isActive,
                      children: t(title)
                    })
                  }, title);
                })
              })
            }), /*#__PURE__*/_jsx(ActionButtons, {
              children: /*#__PURE__*/_jsxs(Grid, {
                flow: "column",
                align: "center",
                gap: "normal1",
                "data-testid": "action-buttons-grid",
                children: [showSpinner && /*#__PURE__*/_jsx(Spinner, {}), showDefaultButtons && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(DesktopView, {
                    showAll: showSignInOnBanner,
                    children: /*#__PURE__*/_jsx(Link, {
                      href: loginUrl,
                      passHref: true,
                      legacyBehavior: true,
                      children: /*#__PURE__*/_jsx(Button, {
                        "data-testid": "header-login-button",
                        variant: "secondary",
                        weight: "bold",
                        as: "a",
                        children: t('sign-in')
                      })
                    })
                  }), !hideJoinButton && /*#__PURE__*/_jsx(Button, {
                    "data-testid": "header-join-now-button",
                    variant: "primary",
                    as: "a",
                    mode: mobileNavState === RenderState.OPEN ? 'dark' : 'light',
                    weight: "bold",
                    onClick: joinButtonOnClick,
                    children: t('header.nav.sign-up-cta')
                  })]
                }), showAccountButtons && /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Link, {
                    href: basePoplarURL,
                    passHref: true,
                    legacyBehavior: true,
                    children: /*#__PURE__*/_jsx(Button, {
                      "data-testid": "header-view-todos-button",
                      as: "a",
                      variant: "primary",
                      weight: "bold",
                      target: "_blank",
                      iconRight: /*#__PURE__*/_jsx(OpenNewWindowIcon, {
                        height: 13.5,
                        width: 13.5
                      }),
                      children: t('view-todos')
                    })
                  }), /*#__PURE__*/_jsx(DesktopView, {
                    children: /*#__PURE__*/_jsx(Dropdown, {
                      ariaLabelledby: userMenuDropdown,
                      open: desktopMenuState === RenderState.OPEN,
                      onClose: function onClose() {
                        return setDesktopMenuState(RenderState.CLOSED);
                      },
                      minWidth: 240,
                      wrappedElement: /*#__PURE__*/_jsx(AvatarWrap, {
                        "aria-expanded": desktopMenuState === RenderState.OPEN,
                        "aria-haspopup": true,
                        "aria-label": t('account'),
                        "data-testid": userMenuDropdown,
                        id: userMenuDropdown,
                        onClick: function onClick() {
                          return setDesktopMenuState(RenderState.OPEN);
                        },
                        children: /*#__PURE__*/_jsxs(Grid, {
                          columns: "1fr auto",
                          gap: "small3",
                          align: "center",
                          children: [/*#__PURE__*/_jsx(Avatar, {
                            size: "md",
                            image: user === null || user === void 0 ? void 0 : (_user$profile = user.profile) === null || _user$profile === void 0 ? void 0 : _user$profile.profileImageUrl,
                            fallbackImage: userAvatarFallback.src,
                            alt: t('avatar-alt-text', {
                              name: user === null || user === void 0 ? void 0 : (_user$profile2 = user.profile) === null || _user$profile2 === void 0 ? void 0 : (_user$profile2$name = _user$profile2.name) === null || _user$profile2$name === void 0 ? void 0 : _user$profile2$name.givenName
                            })
                          }), /*#__PURE__*/_jsx(StyledCaretDownIcon, {
                            size: 16
                          })]
                        })
                      }),
                      children: /*#__PURE__*/_jsx(UserMenuLinks, {})
                    })
                  }), /*#__PURE__*/_jsx(MobileView, {
                    children: /*#__PURE__*/_jsx(AvatarWrap, {
                      "aria-expanded": mobileMenuState === RenderState.OPEN,
                      "aria-haspopup": true,
                      "aria-label": t('account'),
                      "data-testid": userMenuDropdown,
                      onClick: function onClick() {
                        return setMobileMenuState(RenderState.OPEN);
                      },
                      children: /*#__PURE__*/_jsxs(Grid, {
                        columns: "1fr auto",
                        gap: "normal1",
                        align: "center",
                        children: [/*#__PURE__*/_jsx(Avatar, {
                          size: "xs",
                          image: user === null || user === void 0 ? void 0 : (_user$profile3 = user.profile) === null || _user$profile3 === void 0 ? void 0 : _user$profile3.profileImageUrl,
                          fallbackImage: userAvatarFallback.src,
                          alt: t('avatar-alt-text', {
                            name: user === null || user === void 0 ? void 0 : (_user$profile4 = user.profile) === null || _user$profile4 === void 0 ? void 0 : (_user$profile4$name = _user$profile4.name) === null || _user$profile4$name === void 0 ? void 0 : _user$profile4$name.givenName
                          })
                        }), /*#__PURE__*/_jsx(StyledCaretDownIcon, {
                          size: 16
                        })]
                      })
                    })
                  })]
                }), /*#__PURE__*/_jsx(MenuButton, {
                  isOpen: mobileNavState === RenderState.OPEN,
                  onClick: toggleMobileNav
                })]
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(MobileNavContainer, {
          bodyOpenClassName: "no-scroll",
          hasCloseButton: false,
          onClose: function onClose() {
            return setMobileNavState(RenderState.CLOSED);
          },
          state: mobileNavState,
          isNavigating: isNavigating,
          children: /*#__PURE__*/_jsxs(MobileNavGrid, {
            justify: "start",
            gap: "normal3",
            isBannerVisible: isBannerVisible,
            children: [navLinks === null || navLinks === void 0 ? void 0 : navLinks.map(function (_ref4) {
              var title = _ref4.title,
                  href = _ref4.href;
              return /*#__PURE__*/_jsx(Link, {
                href: href,
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/_jsx(Title, {
                  as: "a",
                  size: isJapanLocale ? 'sm' : 'md',
                  variant: "inverse",
                  onClick: function onClick(e) {
                    return handleLinkClicked(e, href);
                  },
                  children: t(title)
                })
              }, title);
            }), showAccountButtons && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(MobileNavigationDivider, {}), /*#__PURE__*/_jsx(Text, {
                as: "a",
                size: "md",
                variant: "inverse",
                href: PAGE_ACCOUNT(basePoplarURL),
                target: "_blank",
                children: t('header.nav.account')
              }), /*#__PURE__*/_jsx("a", {
                href: API_LOGOUT,
                onClick: function onClick() {
                  logoutEvent(mixpanel.domain);
                },
                children: /*#__PURE__*/_jsx(Text, {
                  variant: "inverse",
                  size: "md",
                  children: t('sign-out')
                })
              })]
            }), showDefaultButtons && !showSignInOnBanner && /*#__PURE__*/_jsx(ButtonWrapper, {
              children: /*#__PURE__*/_jsx(Link, {
                href: loginUrl,
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/_jsx(Button, {
                  "data-testid": "mobile-sign-in-btn",
                  as: "a",
                  variant: "primary",
                  mode: "dark",
                  children: t('sign-in')
                })
              })
            })]
          })
        }), /*#__PURE__*/_jsxs(MobileNavContainer, {
          bodyOpenClassName: "no-scroll",
          colorMode: ColorMode.LIGHT,
          hasCloseButton: true,
          onClose: function onClose() {
            return setMobileMenuState(RenderState.CLOSED);
          },
          state: mobileMenuState,
          isNavigating: isNavigating,
          children: [/*#__PURE__*/_jsx(Spacer, {
            size: "large1"
          }), /*#__PURE__*/_jsx(UserMenuLinks, {
            linkComponent: function linkComponent(_ref5) {
              var link = _ref5.link;
              var Icon = link.icon,
                  id = link.id,
                  label = link.label,
                  path = link.path;

              if (path === API_LOGOUT) {
                return null;
              }

              return /*#__PURE__*/_jsx(LinkWrapper, {
                children: /*#__PURE__*/_jsx(Link, {
                  href: path,
                  passHref: true,
                  legacyBehavior: true,
                  children: /*#__PURE__*/_jsxs(Text, {
                    as: "a",
                    size: "xl",
                    weight: "bold",
                    onClick: function onClick(e) {
                      return handleLinkClicked(e, path);
                    },
                    children: [/*#__PURE__*/_jsx(LinkIconWrapper, {
                      children: Icon && /*#__PURE__*/_jsx(Icon, {
                        size: 24
                      })
                    }), t(label)]
                  })
                })
              }, id);
            }
          }), /*#__PURE__*/_jsx(SignOutLinkWrapper, {
            children: /*#__PURE__*/_jsx("a", {
              href: API_LOGOUT,
              onClick: function onClick() {
                logoutEvent(mixpanel.domain);
              },
              children: /*#__PURE__*/_jsx(Text, {
                size: "lg",
                weight: "bold",
                children: t('sign-out')
              })
            })
          })]
        })]
      })
    })]
  });
};
var StyledCaretDownIcon = styled(CaretDownIcon).withConfig({
  componentId: "sc-1vtts6m-0"
})(["&&{color:", ";}"], getColor('base900'));
var ActionButtons = styled.div.withConfig({
  componentId: "sc-1vtts6m-1"
})(["position:relative;z-index:1;"]);
var MobileView = styled.div.withConfig({
  componentId: "sc-1vtts6m-2"
})(["display:block;", ""], media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var DesktopView = styled.div.withConfig({
  componentId: "sc-1vtts6m-3"
})(["&&{display:", ";", "}"], function (_ref6) {
  var showAll = _ref6.showAll;
  return showAll ? 'initial' : 'none';
}, media.lg(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: initial;\n  "]))));
var LinkWrapper = styled.div.withConfig({
  componentId: "sc-1vtts6m-4"
})(["display:flex;border-bottom:1px solid ", ";padding-bottom:", ";margin-bottom:", ";a{align-items:center;align-self:auto;color:", ";display:flex;}"], getColor('base100'), getSpace('normal1'), getSpace('normal1'), getColor('baseA700'));
var LinkIconWrapper = styled.span.withConfig({
  componentId: "sc-1vtts6m-5"
})(["display:inline-block;height:", ";margin-right:", ";width:", ";"], getSpace('normal2'), getSpace('normal2'), getSpace('normal2'));
var SignOutLinkWrapper = styled.div.withConfig({
  componentId: "sc-1vtts6m-6"
})(["position:absolute;bottom:0;left:0;border-bottom:2px solid ", ";a{color:", ";}"], getColor('baseA700'), getColor('baseA700'));
var ButtonWrapper = styled.div.withConfig({
  componentId: "sc-1vtts6m-7"
})(["display:grid;justify-content:start;"]);
var MobileNavGrid = styled(Grid).withConfig({
  componentId: "sc-1vtts6m-8"
})(["&&{margin-top:", ";@media screen and (max-width:", "px){grid-gap:1.5rem;}}"], function (_ref7) {
  var isBannerVisible = _ref7.isBannerVisible;
  return getSpace(isBannerVisible ? 'xl4' : 'xl1');
}, breakpoints.sm);
var MobileNavigationDivider = styled.hr.withConfig({
  componentId: "sc-1vtts6m-9"
})(["background:", ";border:none;height:1px;margin:0;width:", ";"], getColor('base000'), getSpace('normal3'));
var DesktopNavigation = styled.nav.withConfig({
  componentId: "sc-1vtts6m-10"
})(["display:grid;grid-auto-flow:column;grid-gap:", ";"], getSpace('small3'));
var AvatarWrap = styled.button.withConfig({
  componentId: "sc-1vtts6m-11"
})(["appearance:none;background:transparent;border:none;color:", ";cursor:pointer;display:none;padding:0;position:relative;", ""], getColor('base400'), media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    display: initial;\n  "]))));
export default Header;